import classNames from 'classnames';
import React, { Children, useContext } from 'react';
import { AsyncPriceCourseCard, AsyncPriceCourseCardContext } from '@udemy/browse-course';
import { useFormatNumber } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Image } from '@udemy/react-core-components';
import { StarRating } from '@udemy/react-merchandising-components';
import styles from "./single-column-course-card.module.css";
const NumStudents = ({
  numStudents
}) => {
  const {
    formatNumber
  } = useFormatNumber();
  return /*#__PURE__*/React.createElement("span", {
    className: classNames('ud-text-sm', styles['num-students'])
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "people",
    label: false,
    size: "xsmall"
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames('ud-heading-sm', styles['num-students-text'])
  }, formatNumber(numStudents)));
};
const CourseImage = ({
  course,
  ...passThroughProps
}) => {
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    src: course.image_50x50,
    srcSet: `${course.image_50x50} 1x, ${course.image_100x100} 2x`,
    alt: "",
    width: 64,
    height: 64,
    className: styles['course-image']
  }, passThroughProps));
};
export const SingleColumnCourseCard = ({
  course,
  cta,
  courseCardProps,
  showInstructorDetails
}) => {
  const context = useContext(AsyncPriceCourseCardContext);
  const isProductCard = context === null || context === void 0 ? void 0 : context.useCourseProductCard;
  return /*#__PURE__*/React.createElement(AsyncPriceCourseCard, Object.assign({}, courseCardProps, {
    size: "small",
    className: styles['course-card'],
    course: course,
    showDetails: false,
    titleClass: 'ud-heading-md',
    renderCourseImage: () => /*#__PURE__*/React.createElement(CourseImage, {
      course: course
    }),
    renderInstructorContent: showInstructorDetails ? undefined : () => null,
    renderRatings: () => /*#__PURE__*/React.createElement("div", {
      className: styles['ratings-content']
    }, /*#__PURE__*/React.createElement(StarRating, {
      showNumber: true,
      rating: course.rating,
      numeric: true
    }), /*#__PURE__*/React.createElement(NumStudents, {
      numStudents: course.num_subscribers
    })),
    renderCourseBadges: (Badges, props) => {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(styles['badge-container'], {
          [styles['has-badges']]: Children.toArray(props.children).length
        })
      }, /*#__PURE__*/React.createElement(Badges, props));
    }
  }, isProductCard && {
    action: cta
  }), !isProductCard ? /*#__PURE__*/React.createElement("div", {
    className: styles['cta']
  }, cta) : null);
};
//# sourceMappingURL=single-column-course-card.react-component.js.map